import React, { useState } from "react";
import { useUser } from "./UserContext";
import { useNavigate } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";
import "./css/AddBeatModal.css";

const AddBeatModal = ({ product, onClose }) => {
  const { addToCart } = useUser();
  const navigate = useNavigate();
  const [selectedTier, setSelectedTier] = useState("basic");

  const cost =
    selectedTier === "basic" ? product.basicCost : product.premiumCost;

  const handleAdd = () => {
    const cartProduct = {
      ...product,
      productType: "beat",
      cost,
      tier: selectedTier,
    };
    addToCart(cartProduct);
    onClose();
  };

  const handleBuyNow = () => {
    const cartProduct = {
      ...product,
      productType: "beat",
      cost,
      tier: selectedTier,
    };

    // ✅ Save to backend (optional if you want consistency)
    addToCart(cartProduct);

    // ✅ Manually construct enriched object (mimics what addToCart adds)
    const enrichedCartProduct = {
      ...cartProduct,
      quantity: 1,
      totalCost: cost,
      productId: product.$id,
      productName: product.beatName,
      imageUrl: product.imageUrl,
      sellerEmail: product.email,
      BEATinfo: JSON.stringify({
        beatId: product.$id,
        beatName: product.beatName,
        artistName: product.artistName,
        cost,
        sellerEmail: product.email,
      }),
    };

    navigate("/checkout", {
      state: {
        cart: [enrichedCartProduct],
        totalPrice: cost,
      },
    });

    onClose();
  };

  return (
    <div className="addBeatModal-overlay">
      <div className="addBeatModal-content">
        <div className="addBeatModal-layout">
          <img
            src={product.imageUrl}
            alt={product.beatName}
            className="beat-thumbnail-modal"
          />
          <div className="addBeatModal-info">
            <h3>{product.beatName}</h3>
            <div className="addBeatModal-tierSelector">
              <div
                className={`tier-option ${
                  selectedTier === "basic" ? "selected" : ""
                }`}
                onClick={() => setSelectedTier("basic")}
              >
                <div className="tier-title">Basic</div>
                <div className="tier-desc">WAV / MP3</div>
                <div className="tier-price">₹{product.basicCost}</div>
              </div>
              {product.stems && JSON.parse(product.stems).length > 0 && (
                <div
                  className={`tier-option ${
                    selectedTier === "premium" ? "selected" : ""
                  }`}
                  onClick={() => setSelectedTier("premium")}
                >
                  <div className="tier-title">Premium</div>
                  <div className="tier-desc">WAV + Stems</div>
                  <div className="tier-price">₹{product.premiumCost}</div>
                </div>
              )}
            </div>
            <button className="addBeatModal-button" onClick={handleAdd}>
              ADD <FaShoppingCart />: ₹{cost}
            </button>
            <button className="buyNow-button" onClick={handleBuyNow}>
              BUY NOW: ₹{cost}
            </button>
          </div>
        </div>
        <button className="addBeatModal-close" onClick={onClose}>
          ✖
        </button>
      </div>
    </div>
  );
};

export default AddBeatModal;
